export default __webpack_public_path__ + "static/logo-bfa4df45f706f7188f8fc235428d9b22.jpeg";